import React, { Component } from "react";
import { Title } from "components/misc";
import { Container } from 'design-react-kit';
import { AdminCourse } from "components/forms/admin";

import { withRouter } from 'react-router-dom';
import { CourseManagerListSection } from './CourseManagerListSection';


class CourseForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      idCourse: parseInt(this.props.match.params.idcourse) > 0 ? this.props.match.params.idcourse : 0,
      idSection: parseInt(this.props.match.params.idsection) > 0 ? this.props.match.params.idsection : 0,
      title: parseInt(this.props.match.params.idcourse) > 0 ? 'Gestione corso' : 'Nuovo corso'
    }
  }

  render() {

    return (
      <>
        <section className="my-4">
          <Container>
            <Title>{this.state.title}</Title>
            <AdminCourse idCourse={this.state.idCourse} />
          </Container>
          {
            (parseInt(this.state.idCourse) > 0) &&
            (<CourseManagerListSection idcourse={parseInt(this.state.idCourse)} idsection={parseInt(this.state.idSection)} />)
          }
        </section>
      </>
    );
  }

}

export default withRouter(CourseForm);
